module.exports = __webpack_public_path__ + "img/purchase-order-proposals.9e6e3f56.svg";